'use client';

import { createContext, PropsWithChildren, useContext } from 'react';
import { ModalProps } from './types';

type ModalContextValue = ModalProps;

export const ModalContext = createContext<ModalContextValue>({} as ModalContextValue);

type ModalContextProviderProps = PropsWithChildren<ModalProps>;
export const ModalContextProvider = ({ children, ...props }: ModalContextProviderProps) => {
    return <ModalContext.Provider value={{ ...props }}>{children}</ModalContext.Provider>;
};

export const useModalContext = () => useContext(ModalContext);
